<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">Add New Patient</h4>
      </template>
      <template v-slot:default>
        <div class="iq-search-bar">
          <form @submit.prevent="onSearch" class="searchbox">
            <input type="text" class="text search-input" placeholder="Search by patient email" v-model="searchInput">
            <span class="search-link" @click="onSearch"><i class="ri-search-line"></i></span>
          </form>
        </div>
        <div class="spinner-border" v-if="searchPending"></div>
        <PatientsList v-if="searchResult.length" :patients="searchResult" onAddPage="true" :showBodyOnly="true"></PatientsList>
        <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-danger" v-if="searchError">
          <div class="iq-alert-text">{{ searchError }}</div>
        </div>
        </template>
    </iq-card>
  </b-container>
</template>
<script>
import { xray } from '../../config/pluginInit'
import PatientsList from '../../components/PatientsList.vue'
import firebaseService from '../../../firebase'
import { httpsCallable } from 'firebase/functions'
import { ref } from 'vue'
import getDocument from '../../services/getDocument'
import { collection, query, where, getDocs } from 'firebase/firestore'

export default {
  name: 'AddUser',
  mounted () {
    xray.index()
  },
  components: { PatientsList },
  setup () {
    const searchInput = ref(null)
    const searchPending = ref(false)
    const searchResult = ref([])
    const searchError = ref(null)
    const firebaseDoctor = firebaseService.firebaseAuth.currentUser
    const { document: doctor } = getDocument('doctors', firebaseDoctor.uid)

    const searchPatientByEmail = httpsCallable(firebaseService.functions, 'searchPatientByEmail')
    const onSearch = async () => {
      searchResult.value = []
      searchPending.value = true
      searchError.value = null

      if (!doctor.value.devices) {
        searchError.value = 'No patients found with this email and your registered devices.'
        return
      }
      const usersRef = collection(firebaseService.db, 'users')
      const q = query(usersRef, where('email', '==', searchInput.value))
      const querySnapshot = await getDocs(q)
      querySnapshot.forEach((doc) => {
        if (doc.data().devices && Object.keys(doc.data().devices).some(key => doctor.value.devices.includes(key))) {
          searchResult.value.push({ ...doc.data(), uid: doc.id, name: doc.data().firstName + ' ' + doc.data().lastName })
        }
      })
      searchPending.value = false
      if (!searchResult.value.length) {
        searchError.value = 'No patients found with this email and your registered devices.'
      }
      // searchPatientByEmail({ email: searchInput.value })
      //   .then(result => {
      //     searchPending.value = false
      //     searchResult.value.push(result.data)
      //     console.log(searchResult.value)
      //   })
      //   .catch(error => {
      //     searchPending.value = false
      //     searchError.value = error.message
      //     console.log(error)
      //   })
    }

    return { onSearch, searchInput, searchPending, searchError, searchResult }
  }
}

</script>

<style scoped>
  span.search-link {
    cursor: pointer;
  }

  .spinner-border {
    margin-top: 15px;
    margin-left: 15px;
  }

  .iq-search-bar {
    margin-bottom: 15px;
  }

  .alert {
    margin-left: 15px;
  }
</style>
